import React from "react";
import PayPalCheckoutButtons from "./PayPalCheckoutButtons";
import StripePaymentForm from "./StripePaymentForm";
import { isOnlineRafflePayment } from "../lib/rafflePaymentChoice";

export const RaffleOnlinePayments = ({ raffle, entry, email, name, onSuccess }) => {
    if (!entry?.entry_id || !isOnlineRafflePayment(entry.payment_method) || entry.cancelled || entry.paid || entry.payment_review) return null;
    const props = { purpose: "raffle", amount: Number(entry.amount_due_usd), raffleId: raffle.id, raffleEntryId: entry.entry_id, donorName: name, donorEmail: email, onSuccess };
    return <section data-testid="raffle-online-payment-options" className="bg-white border border-black/10 rounded-2xl p-5 mt-5 space-y-5">
        <h2 data-testid="raffle-online-payment-heading" className="font-heading text-lg">Pay for your tickets</h2>
        <div data-testid="raffle-paypal-section"><PayPalCheckoutButtons {...props} referenceId={`raffle-${entry.entry_id}`} description={`Reddog raffle: ${raffle.name}`} /></div>
        <div data-testid="raffle-stripe-section"><StripePaymentForm {...props} /></div>
    </section>;
};